import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { CancellationReasonsQuery } from '../../queries/cancellation_reasons_query';
import { UpcomingAppointmentsQuery } from '../../queries/upcoming_appointments_query';
import { AppointmentInfoServant } from '../../servants/appointment_info_servant';
import {
  IActiveVisit,
  IAppointment,
  IAppointmentCancellationForm,
  IAppointmentCancellationReason,
  IAppointmentCard,
  IAppointmentDetails
} from '../../types/appointment_interfaces';
import { IOrganizer } from '../../types/appt_interfaces';

export class AppointmentDetails extends AppointmentInfoServant {
  appointment: IAppointment;
  activeVisit: IActiveVisit;
  appointmentDetails: IAppointmentDetails;
  cancellationForm: IAppointmentCancellationForm;
  isAppointmentCancelled: boolean;
  showCancelForm: boolean;
  private appointmentCalendarEvent: any;
  private iosRegex: RegExp;
  private isCalendarAvailable: boolean;
  private isSyncedToCalendar: boolean;
  private canCheckin: boolean;
  private canCheckout: boolean;
  private isActiveVisit: boolean = false;
  private isDropin: boolean = false;
  private boundAppointmentCancelledCallback: () => void;

  constructor(
    private accountModel: any,
    private ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
    private $state: ng.ui.IStateService,
    private cancelAppointmentCommand: ICommand,
    private checkinAppointmentCommand: ICommand,
    private checkoutAppointmentCommand: ICommand,
    private clearAllAppointmentsDataSourcesCommand: ICommand,
    private phxFocusDelegate: any,
    private loadUpcomingAppointmentsCommand: ICommand,
    private calendarFacade: any,
    private log: any
  ) {
    super();
    this.iosRegex = /[\n\r]/g; // regex for newline and carriage returns which cause ios trouble
    this.activeVisit = this.ngUpcomingAppointmentsQuery.findActiveVisit(this.$state.params.id);
    this.isActiveVisit = !_4.isEmpty(this.activeVisit);
    this.isDropin = !_4.isEmpty(this.activeVisit) && _4.isNull(this.activeVisit.attendance_id);
    if (this.isDropin) {
      this.appointmentDetails = this.generateActiveVsitCardInfo(this.activeVisit);
    } else {
      this.getAppointment();
    }
    this.closeCancelForm = this.closeCancelForm.bind(this);
    this.isCalendarAvailable = !PlatformUtility.isDesktop() && !this.isDropin;
    if (this.isCalendarAvailable) {
      this.appointmentCalendarEvent = {
        title: `General Advising Appointment: ${_.map(this.appointment.student_services, 'name').join(', ')}`,
        location: this.appointment.location.name,
        notes: this.appointment.comments
          ? `Comments: ${this._stripLineBreaks(this.appointment.comments)}.`
          : this._stripLineBreaks(this.appointment.additional_details)
          ? `Additional Details: ${this._stripLineBreaks(this.appointment.additional_details)}`
          : ``,
        startDate: moment.unix(this.appointment.start_timestamp).toDate(),
        endDate: moment.unix(this.appointment.end_timestamp).toDate()
      };
    }
    // Find event in calendar
    if (this.isCalendarAvailable && this.calendarFacade.isCalendarAvailable()) {
      this.calendarFacade.findEvent(this.appointmentCalendarEvent).then((eventIds: string[]) => {
        this.isSyncedToCalendar = !_.isEmpty(eventIds);
      });
    }
    this.isAppointmentCancelled = this._isAppointmentCancelled;
    this.boundAppointmentCancelledCallback = this.appointmentCancelledCallback.bind(this);
    this.canCheckin = this.isActiveVisit ? false : _4.get(this.appointment, '_canCheckin', false);
    this.canCheckout = this.isDropin ? this.activeVisit.can_checkout : _4.get(this.appointment, '_canCheckout', false);
  }

  getAppointment() {
    const attendanceId = _4.isEmpty(this.activeVisit)
      ? this.$state.params.id
      : this.activeVisit.attendance_id.toString();
    if (_4.isNil(this.ngUpcomingAppointmentsQuery.findAppointment(attendanceId))) {
      this.loadUpcomingAppointmentsCommand().then(() => {
        this.appointment = this.ngUpcomingAppointmentsQuery.findAppointment(attendanceId);
        this.appointmentDetails = this.generateAppointmentDetails(this.appointment, this.studentFullname);
      });
    } else {
      this.appointment = this.ngUpcomingAppointmentsQuery.findAppointment(attendanceId);
      this.appointmentDetails = this.generateAppointmentDetails(this.appointment, this.studentFullname);
    }
  }

  private _stripLineBreaks(unescapedString: string): string {
    return unescapedString ? unescapedString.replace(this.iosRegex, ' ') : '';
  }

  get studentFullname(): string {
    return `${this.accountModel.firstName} ${this.accountModel.lastName}`;
  }

  cancelAppointment() {
    this.showCancelForm = true;
  }

  get _isAppointmentCancelled(): boolean {
    return _4.get(this.appointment, 'is_cancelled', false);
  }

  isPhoneNumber(rawLink: string) {
    return /^\d/g.test(rawLink);
  }

  closeCancelForm(): void {
    this.showCancelForm = false;
  }

  reSchedule(): void {
    this.closeCancelForm();
    this.$state.go('my.appointments');
  }

  appointmentCancelledCallback(cancelForm: any) {
    this.cancellationForm = cancelForm.cancellationForm;
    this.isAppointmentCancelled = true;
    this.closeCancelForm();
    if (this.isCalendarAvailable && this.calendarFacade.isCalendarAvailable()) {
      this.calendarFacade.deleteEvent(this.appointmentCalendarEvent);
    }
  }

  // Add event to calendar
  addToCalendar(): void {
    if (this.isCalendarAvailable && this.calendarFacade.isCalendarAvailable()) {
      this.calendarFacade.registerEvent(this.appointmentCalendarEvent).then((eventIds: string[]) => {
        this.isSyncedToCalendar = !_.isEmpty(eventIds);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointment_details/appointment_details.ts